import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass } from '@angular/common';

import { CcsSkeletonRadiusEnum } from './enums';
import { CcsSkeletonRadius } from './interfaces';

@Component({
  selector: 'app-ccs-skeleton',
  standalone: true,
  imports: [NgClass],
  template: `
    <div
      [style.width]="width()"
      [style.height]="height()"
      class="animate-pulse bg-gray-300"
      [ngClass]="'rounded-' + radius()"></div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CcsSkeletonComponent {
  public width = input<string>('100%');
  public height = input<string>('100%');
  public radius = input<CcsSkeletonRadius>(CcsSkeletonRadiusEnum.md);
}
